import { useContext } from "react";
import { MdArrowForward, MdClose } from "react-icons/md";
import { AppContext } from "../App";
import logo from "../assets/logo.png";

export default function SideBar(props) {
  const appContext = useContext(AppContext);

  const navItems = [
    {
      label: "Home",
      item: "home",
    },
    {
      label: "About Us",
      item: "about_us",
    },
    {
      label: "Products",
      item: "products",
    },
    {
      label: "Portfolio",
      item: "gallery",
    },
    {
      label: "Contact Us",
      item: "contact_us",
    },
  ];

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({
      item,
    });

    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  function isActive(item, label) {
    if (!appContext.navItem && item === "home") return true;
    return appContext.navItem === item;
  }

  return (
    <div className="SideBar mShadow2" data-open={appContext.isSideBarOpen}>
      <div className="body mNoScrollBar">
        <div className="sidebar-header">
          <img
            src={logo}
            alt="Esmeriser"
            className="sidebar-logo-img"
            onClick={() => goTo("home")}
          />

          <button
            type="button"
            className="sidebar-close-btn"
            onClick={appContext.closeSideBar}
            aria-label="Close menu"
          >
            <MdClose size={28} />
          </button>
        </div>

        <div className="sidebar-menu">
          {navItems.map((navItem) => (
            <button
              type="button"
              className="pill"
              key={navItem.label}
              onClick={() => goTo(navItem.item)}
              data-active={isActive(navItem.item, navItem.label)}
            >
              <span className="text">{navItem.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
